registerComponent("pages/search", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Nada de jQuery aqui desde sempre: o `$(component)` de 2020 estava comentado e
 * o resto já era vanilla. A transposição tira a linha comentada (o grep do
 * portão a ignoraria, mas ela aponta para uma lib que não existe mais) e guarda
 * o `<select>` numa const, como em `pages/videos-internal`.
 *
 * O `#limit` é o seletor de itens por página: reescreve `location.search` e
 * recarrega. Quem valida o valor de verdade é o `in_array` do Blade — a lista
 * daqui só existe para devolver o `<option>` selecionado depois do recarregamento.
 */

const limitSelect = document.getElementById('limit');

limitSelect.addEventListener('change', function (event) {
    event.preventDefault();

    const params = new URLSearchParams(window.location.search);
    params.set('limit', this.value);

    window.location.search = params;
});

const limits = [10, 20, 30];
let limit = new URLSearchParams(window.location.search).get('limit');

if (limit) {
    limit = parseInt(limit, 10);
    limitSelect.value = limits.indexOf(limit) !== -1 ? limit : 10;
}

});
